// personalised-metafield-injector.js

(function () {
  'use strict';

  const PREGNANCY_KEY = 'vitable_pregnancy';
  const ALLERGY_KEY = 'vitable_allergy';

  /**
   * Sync metafields to localStorage if present
   * These values are injected into the page via Liquid
   */
  function syncMetafieldsIfLoggedIn() {
    try {
      const pregnancy = window.__vitableMetafields?.pregnancy;
      const allergy = window.__vitableMetafields?.allergy;

      if (pregnancy) {
        localStorage.setItem(PREGNANCY_KEY, pregnancy);
        console.log('[Metafield Injector] Set pregnancy:', pregnancy);
      }

      if (allergy) {
        localStorage.setItem(ALLERGY_KEY, allergy);
        console.log('[Metafield Injector] Set allergy:', allergy);
      }
    } catch (err) {
      console.error('[Metafield Injector] Error syncing metafields:', err);
    }
  }

  /**
   * Remove metafield keys from localStorage if user not logged in
   */
  function clearMetafieldsIfGuest() {
    [PREGNANCY_KEY, ALLERGY_KEY].forEach((key) => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
        console.log(`[Metafield Injector] Removed ${key} (user not logged in)`);
      }
    });
  }

  /**
   * Entry point — choose mode based on data injected via Liquid
   */
  function runMetafieldInjector() {
    const loggedIn = window.__vitableMetafields?.loggedIn === true;

    if (loggedIn) {
      syncMetafieldsIfLoggedIn();
    } else {
      clearMetafieldsIfGuest();
    }
  }

  // Auto-run immediately
  runMetafieldInjector();

})();
